import { useOnboardingStore } from './onboardingStore.js';
import { msg } from '../../lib/messages.js';
import './onboarding.css';

/** First-run "aid to navigation only" gate (spec 01). Blocks until accepted. */
export function DisclaimerGate(): JSX.Element | null {
  const show = useOnboardingStore((s) => s.showDisclaimer);
  const accept = useOnboardingStore((s) => s.acceptDisclaimer);
  if (!show) return null;

  return (
    <div className="onboard-backdrop">
      <div className="onboard" role="dialog" aria-modal="true">
        <div className="onboard__badge" aria-hidden="true">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 9v4M12 17h.01M10.3 3.6L2 18a2 2 0 001.7 3h16.6a2 2 0 001.7-3L14 3.6a2 2 0 00-3.4 0z" />
          </svg>
        </div>
        <h1 className="onboard__title numeral">{msg.disclaimer.title}</h1>
        <p className="onboard__body">{msg.disclaimer.body}</p>
        <button type="button" className="btn btn--accent onboard__ok" onClick={accept}>
          {msg.disclaimer.accept}
        </button>
      </div>
    </div>
  );
}
